const state = {
	sponsorList: []
}

const mutations = {
	'SET_SPONSORS' (state, sponsorList) {
		if (sponsorList) {
			state.sponsorList = sponsorList;
		}
	}
}

const getters = {
	sponsorList: (state) => {
		return state.sponsorList;
	}
}

export default {
	state,
	mutations,
	getters
}